// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__1IQ4y","background":"Layout_background__3Tc0z"};